var map = {
	"./actions-v2.svg": [
		55575,
		5575
	],
	"./actions.svg": [
		28570,
		8570
	],
	"./add-to-calendar.svg": [
		58671,
		8671
	],
	"./app-store-download.svg": [
		1299,
		1299
	],
	"./apply.svg": [
		4773,
		4773
	],
	"./arrow-button-left.svg": [
		52087,
		2087
	],
	"./arrow-button-right.svg": [
		24029,
		4029
	],
	"./arrow-up.svg": [
		14971,
		4971
	],
	"./badge.svg": [
		62479,
		2479
	],
	"./bookmark.svg": [
		3302,
		3302
	],
	"./bullet.svg": [
		59692,
		9692
	],
	"./calendar-new.svg": [
		38848,
		8848
	],
	"./calendar.svg": [
		97651,
		7651
	],
	"./camera.svg": [
		84459,
		4459
	],
	"./campaigns.svg": [
		10363,
		363
	],
	"./cancel.svg": [
		3967,
		3967
	],
	"./candidate-profile.svg": [
		69318,
		9318
	],
	"./category.svg": [
		51054,
		1054
	],
	"./caution.svg": [
		58460,
		8460
	],
	"./check-contained.svg": [
		33803,
		3803
	],
	"./chevron-down.svg": [
		26057,
		6057
	],
	"./chevron-left.svg": [
		78917,
		8917
	],
	"./chevron-right.svg": [
		78521,
		8521
	],
	"./chevron-up.svg": [
		52410,
		2410
	],
	"./clock.svg": [
		96076,
		6076
	],
	"./close.svg": [
		17412,
		7412
	],
	"./copy-to-clipboard.svg": [
		49114,
		9114
	],
	"./copy.svg": [
		27623,
		7623
	],
	"./cv-upload.svg": [
		36250,
		6250
	],
	"./dashboard.svg": [
		73691,
		3691
	],
	"./desert.svg": [
		46250,
		3604
	],
	"./discussion-filled.svg": [
		80305,
		305
	],
	"./discussion.svg": [
		47891,
		7891
	],
	"./dislike.svg": [
		55461,
		5461
	],
	"./doc-upload.svg": [
		57302,
		7302
	],
	"./double-chevron-right.svg": [
		43119,
		3119
	],
	"./double-tick-mark.svg": [
		29358,
		9358
	],
	"./download.svg": [
		37755,
		7755
	],
	"./draft-status.svg": [
		77263,
		7263
	],
	"./draft.svg": [
		45423,
		5423
	],
	"./drag-and-drop.svg": [
		3748,
		3748
	],
	"./edit-new.svg": [
		27807,
		7807
	],
	"./edit-v2.svg": [
		73872,
		3872
	],
	"./edit.svg": [
		11658,
		1658
	],
	"./envelope.svg": [
		69637,
		9637
	],
	"./error.svg": [
		19984,
		9984
	],
	"./export.svg": [
		9128,
		9128
	],
	"./external-link.svg": [
		87961,
		7961
	],
	"./eye-black.svg": [
		44124,
		4124
	],
	"./eye-close.svg": [
		24621,
		4621
	],
	"./eye-filled.svg": [
		83960,
		3960
	],
	"./eye-open.svg": [
		35785,
		5785
	],
	"./facebook.svg": [
		91667,
		1667
	],
	"./file-icon.svg": [
		56955,
		6955
	],
	"./file_type_csv.svg": [
		40107,
		107
	],
	"./file_type_doc.svg": [
		50869,
		869
	],
	"./file_type_pdf.svg": [
		78199,
		8199
	],
	"./file_type_ppt.svg": [
		34019,
		4019
	],
	"./file_type_xls.svg": [
		84894,
		4894
	],
	"./filter-2.svg": [
		59886,
		9886
	],
	"./filter-new.svg": [
		64346,
		4346
	],
	"./filter.svg": [
		83365,
		3365
	],
	"./flying-letter.svg": [
		92638,
		2638
	],
	"./folder.svg": [
		99057,
		9057
	],
	"./group.svg": [
		77855,
		7855
	],
	"./hamburger.svg": [
		46172,
		6172
	],
	"./heart-filled.svg": [
		20569,
		569
	],
	"./heart.svg": [
		33244,
		3244
	],
	"./home.svg": [
		75765,
		5765
	],
	"./horizontal-menu.svg": [
		2189,
		2189
	],
	"./huzzle-new.svg": [
		11532,
		1532
	],
	"./huzzle-profile.svg": [
		66178,
		6178
	],
	"./huzzle-small.svg": [
		71879,
		1879
	],
	"./huzzle-verified.svg": [
		37193,
		7193
	],
	"./huzzle.recruiter.svg": [
		61841,
		1841
	],
	"./huzzle.society.svg": [
		32936,
		2936
	],
	"./huzzle.svg": [
		14153,
		4153
	],
	"./icon_achievement.svg": [
		43141,
		3141
	],
	"./icon_add-emoji-outline-regular-small.svg": [
		27881,
		7881
	],
	"./icon_add-emoji.svg": [
		58028,
		8028
	],
	"./icon_apple.svg": [
		96893,
		6893
	],
	"./icon_arrow-backward.svg": [
		69923,
		9923
	],
	"./icon_arrow-down-2.svg": [
		95117,
		5564
	],
	"./icon_arrow-down.svg": [
		55588,
		5588
	],
	"./icon_arrow-forward.svg": [
		37308,
		7308
	],
	"./icon_arrow-left-2.svg": [
		94703,
		4703
	],
	"./icon_arrow-left.svg": [
		33843,
		3843
	],
	"./icon_arrow-right-2-bold.svg": [
		52629,
		2629
	],
	"./icon_arrow-right-2.svg": [
		15762,
		5762
	],
	"./icon_arrow-up-2.svg": [
		49949,
		9949
	],
	"./icon_arrows-maximize-2.svg": [
		19684,
		9684
	],
	"./icon_arrows-maximize.svg": [
		34986,
		4986
	],
	"./icon_attach.svg": [
		5666,
		5666
	],
	"./icon_badge-filled.svg": [
		67091,
		7091
	],
	"./icon_badge.svg": [
		20233,
		233
	],
	"./icon_ban.svg": [
		11732,
		1732
	],
	"./icon_bar_chart.svg": [
		52956,
		2956
	],
	"./icon_bicep.svg": [
		35283,
		5283
	],
	"./icon_blog.svg": [
		45103,
		5103
	],
	"./icon_bolt-filled.svg": [
		45152,
		5152
	],
	"./icon_bolt-outline.svg": [
		88907,
		8907
	],
	"./icon_bolt.svg": [
		51824,
		1824
	],
	"./icon_bookmark-filled.svg": [
		58334,
		8334
	],
	"./icon_bookmark.svg": [
		65008,
		5008
	],
	"./icon_briefcase.svg": [
		4188,
		4188
	],
	"./icon_briefcase_filled.svg": [
		97519,
		7519
	],
	"./icon_calendar-2.svg": [
		81885,
		1885
	],
	"./icon_calendar.svg": [
		45293,
		5293
	],
	"./icon_camera-flash.svg": [
		40090,
		90
	],
	"./icon_chat-filled.svg": [
		60361,
		361
	],
	"./icon_chat.svg": [
		44363,
		4363
	],
	"./icon_check-all.svg": [
		42689,
		2689
	],
	"./icon_check-double.svg": [
		10815,
		815
	],
	"./icon_check-list.svg": [
		60512,
		512
	],
	"./icon_check-new.svg": [
		11346,
		1346
	],
	"./icon_check.svg": [
		16050,
		6050
	],
	"./icon_checkbox-selected.svg": [
		63635,
		3635
	],
	"./icon_checkbox-unselected.svg": [
		15110,
		5110
	],
	"./icon_chevron-left.svg": [
		86230,
		6230
	],
	"./icon_chevron-right.svg": [
		17496,
		7496
	],
	"./icon_clock.svg": [
		72179,
		2179
	],
	"./icon_close.svg": [
		38691,
		8691
	],
	"./icon_code-outline-regular-small.svg": [
		7486,
		7486
	],
	"./icon_coins.svg": [
		80368,
		368
	],
	"./icon_coins_filled.svg": [
		84627,
		4627
	],
	"./icon_comment.svg": [
		33725,
		3725
	],
	"./icon_compass-filled.svg": [
		98536,
		8536
	],
	"./icon_compass.svg": [
		34976,
		9891
	],
	"./icon_copy.svg": [
		79298,
		9298
	],
	"./icon_cross-circled.svg": [
		5095,
		5095
	],
	"./icon_crown.svg": [
		99481,
		9481
	],
	"./icon_direction-right.svg": [
		98521,
		3070
	],
	"./icon_document-2.svg": [
		53706,
		3706
	],
	"./icon_dot.svg": [
		7372,
		7372
	],
	"./icon_download.svg": [
		89161,
		9161
	],
	"./icon_ellipsis.svg": [
		59610,
		9610
	],
	"./icon_facebook.svg": [
		82008,
		2008
	],
	"./icon_factory.svg": [
		83439,
		3439
	],
	"./icon_filter-2.svg": [
		9126,
		9126
	],
	"./icon_filter_2.svg": [
		5009,
		5009
	],
	"./icon_gear.svg": [
		30602,
		602
	],
	"./icon_goal.svg": [
		59964,
		9964
	],
	"./icon_google.svg": [
		40590,
		590
	],
	"./icon_handshake.svg": [
		58161,
		8161
	],
	"./icon_handshake_filled.svg": [
		76185,
		6185
	],
	"./icon_hat-university.svg": [
		36664,
		6425
	],
	"./icon_hide.svg": [
		5035,
		5035
	],
	"./icon_home-fill.svg": [
		36146,
		6146
	],
	"./icon_home.svg": [
		17420,
		7420
	],
	"./icon_hourglass-outline.svg": [
		80502,
		502
	],
	"./icon_huzzlerecruiter.svg": [
		25493,
		5493
	],
	"./icon_image.svg": [
		85228,
		5228
	],
	"./icon_inbox.svg": [
		10648,
		648
	],
	"./icon_info-outline.svg": [
		41756,
		1756
	],
	"./icon_info.svg": [
		45011,
		5011
	],
	"./icon_instagram.svg": [
		31972,
		1972
	],
	"./icon_launch.svg": [
		61777,
		1777
	],
	"./icon_layout-11.svg": [
		45848,
		5848
	],
	"./icon_left-arrow-2.svg": [
		30702,
		702
	],
	"./icon_link.svg": [
		96109,
		6109
	],
	"./icon_linkedin.svg": [
		30344,
		344
	],
	"./icon_loader.svg": [
		43037,
		3037
	],
	"./icon_logout.svg": [
		57677,
		7677
	],
	"./icon_magic-wand.svg": [
		19538,
		9538
	],
	"./icon_mail.svg": [
		33233,
		3233
	],
	"./icon_mail_filled.svg": [
		61282,
		1282
	],
	"./icon_mailbox-with-letter.svg": [
		59976,
		9976
	],
	"./icon_medal.svg": [
		58053,
		8053
	],
	"./icon_megaphone.svg": [
		2554,
		2554
	],
	"./icon_menu.svg": [
		16706,
		6706
	],
	"./icon_menu_bold.svg": [
		18062,
		8062
	],
	"./icon_microphone.svg": [
		76472,
		6472
	],
	"./icon_minimise.svg": [
		52219,
		2219
	],
	"./icon_minus-circle.svg": [
		6766,
		6766
	],
	"./icon_multiple-11.svg": [
		58177,
		8177
	],
	"./icon_multiple-11_filled.svg": [
		10789,
		789
	],
	"./icon_net-zero.svg": [
		10162,
		162
	],
	"./icon_new-edit.svg": [
		50767,
		767
	],
	"./icon_new_layout-11.svg": [
		66301,
		6301
	],
	"./icon_notification-bell-disabled.svg": [
		73888,
		4309
	],
	"./icon_notification-bell.svg": [
		72457,
		2457
	],
	"./icon_office-chair.svg": [
		49196,
		9196
	],
	"./icon_office-filled.svg": [
		33640,
		3640
	],
	"./icon_paint-up.svg": [
		56152,
		6152
	],
	"./icon_paint-up_filled.svg": [
		8711,
		8711
	],
	"./icon_party.svg": [
		19314,
		9314
	],
	"./icon_party_filled.svg": [
		3082,
		3082
	],
	"./icon_pen-23.svg": [
		30562,
		562
	],
	"./icon_pencil-filled.svg": [
		12788,
		9492
	],
	"./icon_pencil.svg": [
		19432,
		9432
	],
	"./icon_pin.svg": [
		4182,
		4182
	],
	"./icon_placeholder.svg": [
		95411,
		5411
	],
	"./icon_plus-circle.svg": [
		45441,
		5441
	],
	"./icon_plus.svg": [
		33880,
		3880
	],
	"./icon_producthunt.svg": [
		20053,
		53
	],
	"./icon_profile-fill.svg": [
		62174,
		2174
	],
	"./icon_profile.svg": [
		84337,
		4337
	],
	"./icon_progress-2.svg": [
		56505,
		6505
	],
	"./icon_progress.svg": [
		67627,
		7627
	],
	"./icon_qrCode.svg": [
		53311,
		3311
	],
	"./icon_restore.svg": [
		95253,
		5253
	],
	"./icon_right-arrow.svg": [
		8639,
		8639
	],
	"./icon_search-fill.svg": [
		35691,
		4144
	],
	"./icon_search.svg": [
		46898,
		6898
	],
	"./icon_send-message.svg": [
		28288,
		8288
	],
	"./icon_spaceship-filled.svg": [
		75700,
		5700
	],
	"./icon_spaceship.svg": [
		73322,
		3322
	],
	"./icon_sport-mode.svg": [
		28548,
		8548
	],
	"./icon_star-outline.svg": [
		82792,
		2792
	],
	"./icon_star.svg": [
		39615,
		9615
	],
	"./icon_stopwatch.svg": [
		29870,
		9870
	],
	"./icon_su.svg": [
		35448,
		5448
	],
	"./icon_table.svg": [
		57036,
		7036
	],
	"./icon_thumb-up.svg": [
		85957,
		5957
	],
	"./icon_tick-mark.svg": [
		46089,
		8797
	],
	"./icon_tippy_x.svg": [
		82373,
		2373
	],
	"./icon_tippy_y.svg": [
		14518,
		4518
	],
	"./icon_trash.svg": [
		41066,
		1066
	],
	"./icon_users-wm-fill-regular-small-fill.svg": [
		85247,
		5247
	],
	"./icon_users-wm-fill-regular-small.svg": [
		24393,
		4393
	],
	"./icon_users.svg": [
		41063,
		1063
	],
	"./icon_volume-mute.svg": [
		29425,
		9425
	],
	"./icon_web.svg": [
		36218,
		6218
	],
	"./icon_x.svg": [
		13384,
		3384
	],
	"./info-emoji.svg": [
		90922,
		922
	],
	"./info.svg": [
		45493,
		6874
	],
	"./information.svg": [
		1362,
		1362
	],
	"./insta-bookmark.svg": [
		4538,
		4538
	],
	"./insta-comment.svg": [
		90565,
		565
	],
	"./insta-heart.svg": [
		84403,
		4403
	],
	"./insta-share.svg": [
		11630,
		1630
	],
	"./instagram.svg": [
		99203,
		9203
	],
	"./internship.svg": [
		86733,
		6733
	],
	"./invite-mail.svg": [
		93046,
		3046
	],
	"./linkedin.svg": [
		80685,
		685
	],
	"./location.svg": [
		46988,
		6988
	],
	"./logo_airbus.svg": [
		31918,
		1918
	],
	"./logo_deloitte.svg": [
		6372,
		6372
	],
	"./logo_google.svg": [
		14946,
		4946
	],
	"./logo_hsbc.svg": [
		26576,
		6576
	],
	"./logout.svg": [
		22049,
		2049
	],
	"./long-right-arrow.svg": [
		49995,
		9995
	],
	"./meeting-link.svg": [
		18856,
		8856
	],
	"./message.svg": [
		97871,
		7871
	],
	"./messages.svg": [
		36089,
		6089
	],
	"./new-campaign.svg": [
		89612,
		9612
	],
	"./notification.svg": [
		63652,
		3652
	],
	"./office.svg": [
		42910,
		2910
	],
	"./percentage.svg": [
		85296,
		5296
	],
	"./photo-upload.svg": [
		96594,
		6594
	],
	"./play-store-download.svg": [
		84423,
		4423
	],
	"./plus-circle.svg": [
		62349,
		2349
	],
	"./plus.svg": [
		21225,
		1225
	],
	"./profile.svg": [
		23882,
		3882
	],
	"./remove.svg": [
		99141,
		9141
	],
	"./replace.svg": [
		50642,
		642
	],
	"./reply.svg": [
		95603,
		5603
	],
	"./report.svg": [
		35402,
		5402
	],
	"./reset.svg": [
		40381,
		381
	],
	"./review-status.svg": [
		38743,
		8743
	],
	"./right-arrow.svg": [
		66994,
		6994
	],
	"./saved.svg": [
		49647,
		9647
	],
	"./screen.svg": [
		45657,
		5657
	],
	"./search.svg": [
		98386,
		8386
	],
	"./setting-black.svg": [
		23795,
		3795
	],
	"./setting.svg": [
		6127,
		6127
	],
	"./share.svg": [
		70524,
		524
	],
	"./societies.svg": [
		56944,
		6944
	],
	"./su.svg": [
		58589,
		8589
	],
	"./success.svg": [
		2091,
		2091
	],
	"./tick-mark-circle.svg": [
		85465,
		5465
	],
	"./tick-mark.svg": [
		89090,
		9090
	],
	"./tick_mark_square.svg": [
		12801,
		2801
	],
	"./trash.svg": [
		84874,
		4874
	],
	"./twitter.svg": [
		72547,
		2547
	],
	"./undo-dislike.svg": [
		19084,
		9084
	],
	"./unfollow.svg": [
		22760,
		2760
	],
	"./unordered_list.svg": [
		32642,
		2642
	],
	"./upload.svg": [
		64233,
		4233
	],
	"./valid-check-mark.svg": [
		35774,
		5774
	],
	"./vector.svg": [
		45117,
		5117
	],
	"./verified.svg": [
		36217,
		6217
	],
	"./warning.svg": [
		87046,
		7046
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 84718;
module.exports = webpackAsyncContext;